import { useSWRConfig } from "swr"

const useClearSWR = (): {
    clearCache: () => Promise<void>
} => {
    const { mutate, cache } = useSWRConfig()

    const clearCache = async (): Promise<void> => {
        const cacheKeys = Array.from(cache.keys())
        await Promise.all(
            cacheKeys.map((key) =>
                mutate(key, undefined, { revalidate: false })
            )
        )
    }

    return { clearCache }
}

export default useClearSWR
